"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var textareaInputStyles = makeStyles_1.default(function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            background: palette.common.white,
        },
    });
}, { name: 'GqlCheckout_TextareaInput' });
exports.default = textareaInputStyles;
